import React from 'react';
import { getTransFunc } from '../SFxLocalization';

var prefix = "sfx-react-ui-";

var Footer = function Footer(props) {
  var transInstance = props.transInstance;
  var trans = getTransFunc(transInstance);
  var copyrightDefault = "".concat(new Date().getFullYear(), " ").concat(trans('SFxFooterFooterMsg'));
  var links = props.links,
      version = props.version,
      _props$copyright = props.copyright,
      copyright = _props$copyright === void 0 ? copyrightDefault : _props$copyright,
      theme = props.theme;
  var dom = /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "footer")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "footer-logo")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "footer-info")
  }, copyright && /*#__PURE__*/React.createElement("span", null, "\xA9 ", copyright)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "footer-link")
  }, links && links.length > 0 && links.map(function (item, index) {
    return /*#__PURE__*/React.createElement("a", {
      rel: "noreferrer",
      href: item.link,
      key: index,
      target: item.target ? item.target : "_blank",
      className: "".concat(prefix, "footer-item text-default-color text-uppercase")
    }, item.name);
  }), version && /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "footer-version")
  }, "v", version)));
  return theme ? /*#__PURE__*/React.createElement("span", {
    className: 'sfx-react-ui-theme',
    "data-theme": theme
  }, dom) : dom;
};

export default Footer;